import angular from 'angular';
import uiRouter from 'angular-ui-router';
import 'angular-i18n/angular-locale_it-it';
import ngTouch from 'angular-touch';
import ngAnimate from 'angular-animate';
import ngSanitize from 'angular-sanitize';
import ngMap from 'ngmap';
import ngRollbar from 'ng-rollbar';
import LocalStorageModule from 'angular-local-storage';
import Common from './common/common';
import Components from './components/components';
import AppServices from './services/services';
import AppComponent from './app.component';
import AppFilters from './filters/filters';
import AppDirectives from './directives/directives';
import 'normalize.css';
import 'bootstrap-loader';
import UIBootstrap from 'angular-ui-bootstrap';
// font awesome css and directive
import 'font-awesome/css/font-awesome.css';
import 'angular-fontawesome';
import Analytics from 'angular-google-analytics';
import 'angular-ui-router-title';

angular.module('app', [
  uiRouter,
  ngTouch,
  ngAnimate,
  ngSanitize,
  ngMap,
  ngRollbar,
  LocalStorageModule,
  Common,
  Components,
  UIBootstrap,
  AppServices,
  AppFilters,
  AppDirectives,
  'picardy.fontawesome',
  Analytics,
  'ui.router.title'
])
  .config(($locationProvider) => {
    "ngInject";
    // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
    // #how-to-configure-your-server-to-work-with-html5mode
    $locationProvider.html5Mode(true).hashPrefix('!');
  })
  .config((localStorageServiceProvider) => {
    'ngInject';
    localStorageServiceProvider.setPrefix('fmConnect').setNotify(true, true);
  })
  .config((RollbarProvider) => {
    'ngInject';
    // ROLLBAR_TOKEN and ROLLBAR_ENV coming from webpack config
    RollbarProvider.init({
      accessToken: ROLLBAR_TOKEN,
      captureUncaught: true,
      payload: {
        environment: ROLLBAR_ENV,
        client: {
          javascript: {
            source_map_enabled: true,
            guess_uncaught_frames: true,
            code_version: CODE_VERSION
          }
        }
      }
    });
  })
  .config((AnalyticsProvider) => {
    'ngInject';
    // Configure google analytics tracking
    AnalyticsProvider
      .setAccount('UA-92796226-1')
      .enterDebugMode(ROLLBAR_ENV == 'development')
      .trackUrlParams(true)
      .ignoreFirstPageLoad(true); // Helpful when using hashes and whenever your bounce rate looks obscenely low.
  })
  .run(($location, $transitions, Analytics) => {
    'ngInject';
    // Track page views when there is a transaction
    $transitions.onSuccess({}, (t) => {
      // Use updated page title when transition is fully resolved
      t.promise.finally(() => Analytics.trackPage($location.path(), document.title));
    });
  })
  .constant('MapsApiKey', 'AIzaSyCNhDhVd7JYPOaTzMma-dEYba9CjO_NHyk')
  .component('app', AppComponent);



// WEBPACK FOOTER //
// ./client/app/app.js